export const COMMUNITY_POST_TYPES = [
  { id: 'success', label: 'Success' },
  { id: 'challenges', label: 'Challenges' },
  { id: 'ideas', label: 'Ideas' },
  { id: 'general', label: 'General' },
  { id: 'announcements', label: 'Announcements' },
  { id: 'questions', label: 'Questions' },
];

export const COMMUNITY_PILLARS = [
  { id: 'sales', label: 'Sales' },
  { id: 'operations', label: 'Operations' },
  { id: 'marketing', label: 'Marketing' },
  { id: 'technology', label: 'Technology' },
  { id: 'finance', label: 'Finance' },
  { id: 'hr', label: 'HR' },
];

export const COMMUNITY_SORT_OPTIONS = [
  { value: 'recent', label: 'Recent' },
  { value: 'top', label: 'Top' },
];

export const COMMUNITY_TYPE_FILTER_OPTIONS = [
  { value: 'all', label: 'All' },
  ...COMMUNITY_POST_TYPES.map((t) => ({ value: t.id, label: t.label })),
];

export const COMMUNITY_PILLAR_FILTER_OPTIONS = [
  { value: 'all', label: 'All' },
  ...COMMUNITY_PILLARS.map((p) => ({ value: p.id, label: p.label })),
];

export const COMMUNITY_TYPE_LABELS = Object.fromEntries(
  COMMUNITY_POST_TYPES.map((t) => [t.id, t.label])
);

export const COMMUNITY_PILLAR_LABELS = Object.fromEntries(
  COMMUNITY_PILLARS.map((p) => [p.id, p.label])
);

export const COMMUNITY_POSTS_PAGE_SIZE = 8;

export function getMemberDisplayName(member) {
  if (member.firstName && member.lastName) {
    return `${member.firstName} ${member.lastName}`.trim();
  }
  return member.displayName || member.email?.split('@')[0] || 'Member';
}

export function getMemberAvatarUrl(member, size = 40) {
  const name = getMemberDisplayName(member);
  return (
    member.photoURL ||
    `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=ef4444&color=ffffff&size=${size}`
  );
}

export function getPostAuthorAvatarUrl(post, size = 40) {
  const fallback = `https://ui-avatars.com/api/?name=${encodeURIComponent(post.author || 'User')}&background=ef4444&color=ffffff&size=${size}`;
  return post.authorAvatar || fallback;
}
